import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Blocked.scss';
import DynamicHeader from '../../Header/DynamicHeader';
import cvantikBlock from '../img/cvantik-block.png';

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API ||
  (typeof window !== 'undefined' &&
  window.location.hostname.includes('onrender.com')
    ? 'https://cvanto-api.onrender.com'
    : 'http://localhost:5000');

const Blocked = () => {
  const { userId } = useAuth();
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlockedUsers = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/block/blocked/${encodeURIComponent(userId)}`
        );
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const data = await res.json();
        setBlockedUsers(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('❌ Не вдалося завантажити заблокованих користувачів', error);
        setBlockedUsers([]);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchBlockedUsers();
  }, [userId]);

  const handleUnblock = async (blockedId) => {
    try {
      const res = await fetch(`${API_BASE}/api/block`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ blockerId: userId, blockedId }),
      });

      if (!res.ok) throw new Error('Не вдалося розблокувати');
      setBlockedUsers((prev) => prev.filter((user) => user.id !== blockedId));
    } catch (err) {
      console.error('❌ Помилка при розблокуванні:', err);
    }
  };

  return (
    <>
      <DynamicHeader
        title="Заблоковані"
        variant="glass"
        size="regular"
        showBack
        withSpacer
      />

      <div className="blocked">
        {loading ? (
          <div className="blocked__skeletonList" aria-hidden="true">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="blocked__skeletonItem">
                <div className="blocked__skeletonAvatar" />
                <div className="blocked__skeletonText">
                  <div className="blocked__skeletonLine blocked__skeletonLine--primary" />
                  <div className="blocked__skeletonLine blocked__skeletonLine--secondary" />
                </div>
                <div className="blocked__skeletonBtn" />
              </div>
            ))}
          </div>
        ) : blockedUsers.length === 0 ? (
          <div className="blocked__emptyWrap">
            <div className="blocked__cvantikWrap" aria-hidden="true">
              <img
                className="blocked__cvantik"
                src={cvantikBlock}
                alt=""
                draggable="false"
              />
            </div>
            <p className="blocked__emptyText">
              Тут порожньо. Схоже, ви знаходите спільну мову з усіма.
            </p>
          </div>
        ) : (
          <div className="blocked__list">
            {blockedUsers.map((user) => (
              <div key={user.id} className="blocked__item">
                <div
                  className="blocked__user"
                  onClick={() => navigate(`/profile/${user.id}`)}
                >
                  <img
                    src={user.avatar}
                    alt={user.username}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src =
                        'https://cvanto-photos.s3.us-east-1.amazonaws.com/DefaultAvatar/avatar.png';
                    }}
                  />
                  <div className="blocked__info">
                    <div className="blocked__username">{user.username}</div>
                    {user.profileType && (
                      <div className="blocked__type">{user.profileType}</div>
                    )}
                  </div>
                </div>

                <button
                  className="blocked__btn"
                  onClick={() => handleUnblock(user.id)}
                  type="button"
                >
                  Розблокувати
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Blocked;
